/* tslint:disable */
/* eslint-disable */
/**
 * WoodmenLifeOrg
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProblemDetails,
} from '../models';

export interface PhotoUploadPostRequest {
    photo?: Blob;
    releaseForm?: Blob;
    submittedByName?: string;
    submittedByPhone?: string;
    submittedByEmail?: string;
    chapterNumber?: number;
    chapterState?: string;
    chapterCity?: string;
    photoNames?: string;
    photoDescription?: string;
    containsMinors?: boolean;
}

/**
 * 
 */
export class PhotoApi extends runtime.BaseAPI {

    /**
     */
    async photoUploadPostRaw(requestParameters: PhotoUploadPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.photo !== undefined) {
            formParams.append('Photo', requestParameters.photo as any);
        }

        if (requestParameters.releaseForm !== undefined) {
            formParams.append('ReleaseForm', requestParameters.releaseForm as any);
        }

        if (requestParameters.submittedByName !== undefined) {
            formParams.append('SubmittedByName', requestParameters.submittedByName as any);
        }

        if (requestParameters.submittedByPhone !== undefined) {
            formParams.append('SubmittedByPhone', requestParameters.submittedByPhone as any);
        }

        if (requestParameters.submittedByEmail !== undefined) {
            formParams.append('SubmittedByEmail', requestParameters.submittedByEmail as any);
        }

        if (requestParameters.chapterNumber !== undefined) {
            formParams.append('ChapterNumber', requestParameters.chapterNumber as any);
        }

        if (requestParameters.chapterState !== undefined) {
            formParams.append('ChapterState', requestParameters.chapterState as any);
        }

        if (requestParameters.chapterCity !== undefined) {
            formParams.append('ChapterCity', requestParameters.chapterCity as any);
        }

        if (requestParameters.photoNames !== undefined) {
            formParams.append('PhotoNames', requestParameters.photoNames as any);
        }

        if (requestParameters.photoDescription !== undefined) {
            formParams.append('PhotoDescription', requestParameters.photoDescription as any);
        }

        if (requestParameters.containsMinors !== undefined) {
            formParams.append('ContainsMinors', requestParameters.containsMinors as any);
        }

        const response = await this.request({
            path: `/Photo/Upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async photoUploadPost(requestParameters: PhotoUploadPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.photoUploadPostRaw(requestParameters, initOverrides);
    }

}
